/*
 * VTee PDP 追従カートバー(Gymshark 風・スクロールで定位置に収まる)
 *
 * 参考(Gymshark PDP)の挙動:
 *   - 最上部では add-to-cart コンテナが position:fixed で画面下に浮く
 *   - スクロールすると position:sticky に切替わり、定位置(フロー上の位置)に来たら
 *     そのままスクロールに乗って上へ流れていく(ワープしない・1要素なので重ならない)
 *
 * 当テーマは商品情報の包含ブロック構造の都合で純粋な position:sticky が使えないため、
 * 「本来のボタン(フロー)」+「追従バー(fixed クローン)」の2要素で上記を“1要素のように”
 * エミュレートする:
 *   - 本来のボタンが追従バーのスロット座標(画面下の固定位置)より下にある間:
 *       追従バーを表示し、本来のボタンは不可視(.vtee-buttons-hidden)にして重なりを防ぐ
 *   - 本来のボタンがスロット座標に到達した瞬間(= 交差開始):
 *       追従バーを消し、同じ座標に本来のボタンを出す(座標一致なのでワープしない)
 *       → 以降は本来のボタンがスクロールに乗って自然に上へ流れる(定位置に収まる)
 *   - 本来のボタンが上へ流れ去った後は追従バーを出さない
 *
 * 判定は IntersectionObserver(scroll/rAF のスロットリングや非アクティブタブの影響を受けない)。
 * root の下端をスロット座標まで縮め、本来のボタンがその領域に交差しているかで切り替える。
 */
(function () {
  'use strict';

  function init() {
    var sticky = document.querySelector('[data-vtee-sticky-cart]');
    var target = document.querySelector('.product-form__buttons');
    if (!sticky || !target) return;

    // inlineBtn = 本来の(フロー上の)カート追加ボタン(位置判定に使用)
    // stickyBtn = 追従バー内のボタン(画面下の固定スロット座標の基準)
    var inlineBtn = target.querySelector('.product-form__submit') || target;
    var stickyBtn = sticky.querySelector('.vtee-sticky-cart__button') || sticky;

    var observer = null;
    var lastFloating = null;

    // floating=true : 追従バー表示 + 本来のボタンを不可視(未到達 → 浮かせる)
    // floating=false: 追従バー非表示 + 本来のボタン表示(定位置に収まった / 通過後)
    function setFloating(floating) {
      if (floating === lastFloating) return;
      lastFloating = floating;
      sticky.classList.toggle('is-visible', floating);
      sticky.setAttribute('aria-hidden', floating ? 'false' : 'true');
      target.classList.toggle('vtee-buttons-hidden', floating);
    }

    function build() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      // 追従バーのボタン上端 = 画面下の固定スロット座標。
      // visibility:hidden でも fixed 要素はレイアウト座標を保持するため計測できる。
      var slotTop = stickyBtn.getBoundingClientRect().top;
      // root(ビューポート)下端をスロット座標まで縮める量。
      var bottomInset = Math.max(0, Math.round(window.innerHeight - slotTop));

      observer = new IntersectionObserver(
        function (entries) {
          var en = entries[entries.length - 1];
          if (en.isIntersecting) {
            // 本来のボタンが [0, スロット座標] に入った = 定位置に到達〜画面内
            // → 追従バーを消し、本来のボタンを出す(同座標なのでワープしない)
            setFloating(false);
          } else {
            // 交差なし: スロットより下(未到達)なら浮かせる / 画面より上(通過後)は出さない
            var slotBottom = en.rootBounds ? en.rootBounds.bottom : slotTop;
            setFloating(en.boundingClientRect.top >= slotBottom);
          }
        },
        {
          root: null,
          rootMargin: '0px 0px -' + bottomInset + 'px 0px',
          threshold: 0,
        }
      );
      observer.observe(inlineBtn);
    }

    // IntersectionObserver 非対応環境向けフォールバック(scroll + 座標比較)
    function fallback() {
      var ticking = false;
      function compute() {
        ticking = false;
        var slotTop = stickyBtn.getBoundingClientRect().top;
        var inlineTop = inlineBtn.getBoundingClientRect().top;
        // 本来のボタンがスロット座標より下(未到達)の時だけ浮かせる。
        // 定位置に到達(スロット座標以上)・通過後は本来のボタンを表示。
        setFloating(inlineTop > slotTop);
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(compute);
      }
      compute();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    if ('IntersectionObserver' in window) {
      build();
      window.addEventListener('resize', build, { passive: true });
    } else {
      fallback();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
